import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Page } from "components/layout/reusableLayouts";
import ActivateCardForm from "components/common/cards/ActivateCardForm";

const ActivateCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Page sx={{ height: "100%" }}>
      <Typography variant="h3" component="h1">
        {t("Activate Card")}
      </Typography>

      <ActivateCardForm />
    </Page>
  );
};

export default ActivateCard;
